import { render, staticRenderFns } from "./RunDetail.vue?vue&type=template&id=6d5b9c16&scoped=true&"
import script from "./RunDetail.vue?vue&type=script&lang=js&"
export * from "./RunDetail.vue?vue&type=script&lang=js&"
import style0 from "./RunDetail.vue?vue&type=style&index=0&id=6d5b9c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5b9c16",
  null
  
)

export default component.exports